import React, { useState } from "react";
import { Order } from "./types";
import { OrderItem } from "./Order";
import * as Sentry from "@sentry/react";
import CancelIcon from "@mui/icons-material/Cancel";
import { RechargeCustomerProvider } from "./RechargeCustomerContext";
import { SubscriptionDrawer } from "./page/SubscriptionDrawer";
import { useCustomer } from "../CustomerContext";
import { AccountPageProvider } from "./AccountPageContext";
import { ModifiedCharge } from "./RechargeApi";

export type AccountPageProps = {
  orders: Order[];
};

interface ErrorAlertProps {
  error: Error;
  eventId: string | null;
}

const ErrorAlert = ({ error, eventId }: ErrorAlertProps) => {
  return (
    <div className="flex flex-col bg-white p-5 shadow" role="alert">
      <div className="item-center mb-2.5 flex space-x-3 md:items-start">
        <CancelIcon htmlColor="var(--color-red)" />
        <div className="flex flex-col">
          <p className="body text-md text-red">
            We are having trouble displaying your orders. Please contact our
            support team to resolve this issue.
          </p>
          <p className="body mt-5 text-md text-red">
            {eventId ? "Error ID: " + eventId : "Error: " + error}
          </p>
        </div>
      </div>
    </div>
  );
};

export const AccountPage = ({ orders }: AccountPageProps) => {
  const [openSubDrawer, setOpenDrawer] = useState(false);
  const [addressId, setaddressId] = useState<number | null>(null);
  const [upcomingCharge, setUpcomingCharge] = useState<ModifiedCharge | null>(
    null
  );
  const customer = useCustomer();

  if (orders.length == 0) return null;

  return (
    <div className="space-y-8">
      <Sentry.ErrorBoundary fallback={ErrorAlert}>
        <RechargeCustomerProvider>
          <AccountPageProvider orders={orders}>
            {orders.map((order) => (
              <OrderItem
                {...order}
                key={order.name}
                subsDrawerAction={(addressId, upcomingCharge) => {
                  setaddressId(addressId);
                  setUpcomingCharge(upcomingCharge);
                  setOpenDrawer(true);
                }}
              />
            ))}

            {customer &&
              customer.hasSubscriptions &&
              addressId &&
              openSubDrawer && (
                <SubscriptionDrawer
                  open={openSubDrawer}
                  onExit={() => {
                    setOpenDrawer(false);
                  }}
                  addressId={addressId}
                  upcomingCharge={upcomingCharge}
                />
              )}
          </AccountPageProvider>
        </RechargeCustomerProvider>
      </Sentry.ErrorBoundary>
    </div>
  );
};
